import checkout from '../modules/checkoutModule';
import filteredProducts from "../modules/filter/filteredProducts";
import initCustomForms from '../modules/initCustomForms';
import initPopups from '../modules/initPopups';
import scrollHidden from '../modules/scrollHidden';
import header from '../modules/header/index';
import addToCardEventInit from "../modules/addToCardEvent";

jQuery(function () {
    header();
    checkout();
    initCustomForms();
    initPopups();
    scrollHidden();
    var brandTitle = $('.data-container').attr('data-title');
    filteredProducts({
        updateGroupFilter: true,
        updateBrandFilter: true,
        apiUrl: '/umbraco/api/products/GetPaginatedWholesales',
        title: brandTitle
    });
    addToCardEventInit();
})